import { useState, useEffect } from 'react';
import appConstants from '../../constants';

const defaults = Object.freeze( {
  initialSelectedForm: appConstants.SEARCH_FORM_DEFAULT,
  initialLastSelectedNonSearchByLocationForm: appConstants.SEARCH_FORM_FILTER_BY_NEED
});

export default function useSearchFormTabNavigation(selectedCountry, initialSelectedForm = defaults.initialSelectedForm, initialLastSelectedNonSearchByLocationForm = defaults.initialLastSelectedNonSearchByLocationForm) {

  const [selectedForm, setSelectedForm] = useState(initialSelectedForm);
  const [lastSelectedNonSearchByLocationForm, setLastSelectedNonSearchByLocationForm] = useState(initialLastSelectedNonSearchByLocationForm);

  function selectSearchForm(form) {
    if (appConstants.SEARCH_FORMS.includes(form)) {
      setSelectedForm(previousValue => form);
      if (form !== appConstants.SEARCH_FORM_SEARCH_BY_LOCATION) {
        setLastSelectedNonSearchByLocationForm(previousValue => form);
      }
    }
    else {
      appConstants.APP_DEBUG_LOGGER(`Invalid form: ${form}`);
    }
  }

  function isFormSelected(form) {
    return form === selectedForm;
  }

  function selectFilterByNeedForm() {
    selectSearchForm(appConstants.SEARCH_FORM_FILTER_BY_NEED);
  }

  function selectSearchByCombinedCriteriaForm() {
    selectSearchForm(appConstants.SEARCH_FORM_SEARCH_BY_COMBINED_CRITERIA);
  }

  function selectSearchByLocationForm() {
    selectSearchForm(appConstants.SEARCH_FORM_SEARCH_BY_LOCATION);
  }

  function selectFormBeforeSearchByLocation() {
    selectSearchForm(lastSelectedNonSearchByLocationForm);
  }

  function isFilterByNeedFormSelected() {
    return isFormSelected(appConstants.SEARCH_FORM_FILTER_BY_NEED);
  }

  function isSearchByCombinedCriteriaFormSelected() {
    return isFormSelected(appConstants.SEARCH_FORM_SEARCH_BY_COMBINED_CRITERIA);
  }

  function isSearchByLocationFormSelected() {
    return isFormSelected(appConstants.SEARCH_FORM_SEARCH_BY_LOCATION);
  }

  function getCurrentSelectedForm() {
    return selectedForm;
  }

  useEffect(
    () => {
      if (!selectedCountry) {
        setSelectedForm(previousValue => appConstants.SEARCH_FORM_SEARCH_BY_LOCATION);
      }
      else {
        setSelectedForm(previousValue => lastSelectedNonSearchByLocationForm);
      }
    },
    [selectedCountry, lastSelectedNonSearchByLocationForm]
  );


  return {
    getCurrentSelectedForm,
    selectFilterByNeedForm,
    selectSearchByCombinedCriteriaForm,
    selectSearchByLocationForm,
    selectFormBeforeSearchByLocation,
    isFilterByNeedFormSelected,
    isSearchByCombinedCriteriaFormSelected,
    isSearchByLocationFormSelected,
    lastSelectedNonSearchByLocationForm
  }
}
